<script setup lang="ts">
const props = defineProps({
	min: {
		type: Number,
		default: 1
	},
	max: {
		type: Number,
		default: 20
	},
	modelValue: {
		type: Number,
		default: 1
	}
});
const emit = defineEmits(["update:modelValue"]);

const decreaseAmount = () => {
	if (props.modelValue <= props.min) { return; }
	emit("update:modelValue", props.modelValue - 1);
};
const increaseAmount = () => {
	if (props.modelValue >= props.max) { return; }
	emit("update:modelValue", props.modelValue + 1);
};
</script>

<template>
	<div>
		<button class="flex items-center justify-center px-4 h-full hover:text-black duration-100" @click="decreaseAmount">
			-
		</button>
		<span>{{ modelValue }}</span>
		<button class="flex items-center justify-center px-4 h-full hover:text-black duration-100" @click="increaseAmount">
			+
		</button>
	</div>
</template>
